import { Operator } from './operator';

export class UserAccount {
  operator: Operator;
  superUser = false;
  eulaAccepted = false;
}
